"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        gap: '5px',
        fontSize: 14,
        lineHeight: '17.75px',
        color: theme.grey3
    },
    item: {
        outline: 'none',
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        gap: '3px',
        color: theme.grey3,
        '&[data-is-last=true]': {
            color: theme.grey2
        },
        '&:disabled': {
            cursor: 'default'
        }
    }
});
//# sourceMappingURL=breadCrumbs.styles.js.map